import localFont from 'next/font/local';

const bliss = localFont({
    display: 'swap',
    src: [
        {
            path: './xlight.woff2',
            weight: '100',
            style: 'normal'
        },
        {
            path: './light.woff2',
            weight: '300',
            style: 'normal'
        },
        {
            path: './regular.woff2',
            weight: '400',
            style: 'normal'
        },
        {
            path: './bold.woff2',
            weight: '700',
            style: 'normal'
        },
        {
            path: './xbold.woff2',
            weight: '800',
            style: 'normal'
        },
        {
            path: './heavy.woff2',
            weight: '900',
            style: 'normal'
        }
    ]
});

export default bliss;
